module.exports = __webpack_public_path__ + "static/img/19-3.3d6427c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/19-3.jpg
// module id = hm4A
// module chunks = 0